import { GapDialogProps } from 'reusable/gap-dialog/GapDialog'
import { messageActions } from './message-actions'

export async function messageWarning(children: string, title = 'Warning', options?: GapDialogProps) {
    if (title === undefined || title === null) {
        title = 'Warning'
    }

    return messageActions({
        title: title,
        children: children,
        primary: {
            name: 'Ok'
        },
        ...options
    })
}
